import { FormControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { UserProfile } from 'src/app/core/models/user';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Component, ElementRef, HostListener, Inject, Input, OnInit, ViewChild } from '@angular/core';
// import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { ImpactAssessment, ImpactAssessmentAssessmentDetailsList, ImpactAssessmentAssessmentDetailsList2 } from './../../../core/models/impact-assessment/impact-assessment';
import { ImpactAssessmentDetailsDD } from 'src/app/core/models/impact-assessment/impact-assessment-details-dd';
import { StatusModel } from 'src/app/core/models/impact-assessment/impact-status-model';
import { ImpactAssessmentDropDownList } from 'src/app/core/models/impact-assessment/impact-assessment-dropdown-list-model';
import { result } from 'underscore';
import { JurisdictionsList } from 'src/app/core/models/impact-assessment/jurisdictions-list-model';
import { JsonPipe } from '@angular/common';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { DeleteDialogComponent } from '../../distributed-ui-components';
// import * as customBuild from './../../../../ckCustomeBuild/build/ckeditor';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-bulk-update-dialog',
  templateUrl: './bulk-update-dialog.component.html',
  styleUrls: ['./bulk-update-dialog.component.scss'],
})
export class BulkUpdateDialogComponent implements OnInit {
  toastModel: ToastViewModel;
  isToastShow = false;
  impactAssessment: ImpactAssessment;
  impactAssessmentDD: ImpactAssessmentDetailsDD;
  isLoadingDD = false;
  userAccessToken: UserProfile;
  isRDetailPermission = true;
  isIDetailPermission = true;
  isADetailPermission = true;
  isRDNotRequired = false;
  isIDNotRequired = false;
  searchStr = '';
  isRDetails = false;
  isIDetails = false;
  isRDPermission = false;
  isIDPermission = false;
  isIADetails1 = false;
  isIADetails2 = false;
  isIADetails3 = false;
  isIADetails4 = false;
  isIADetails5 = false;

  public legalEntityList: any;
  legalEntityDD: legalData[] = [];
  allLegalEntityDD: legalData[] = [];
  selectedEntity: string;
  searchLegalEntityCntrl: FormControl = new FormControl();
  @ViewChild('LegalEntityInput')
  LegalEntityInput!: ElementRef<HTMLInputElement>;
  @ViewChild('legalEntityAutocomplete')
  legalEntityAutocomplete!: MatAutocomplete;

  searchLineOfBusinessCntrl: FormControl = new FormControl();
  @ViewChild('LineOfBusinessInput')
  LineOfBusinessInput!: ElementRef<HTMLInputElement>;
  @ViewChild('lineOfBusinessAutocomplete')
  lineOfBusinessAutocomplete!: MatAutocomplete;
  allLineOfBusiness: Array<string> = [];

  assessorDD: string[] = [];
  assessorDelDD: string[] = [];
  reviewerDD: string[] = [];
  reviewerDelDD: string[] = [];
  imptOwnerDD: string[] = [];
  ownerDelDD: string[] = [];
  topicDD: string[] = [];

  searchedAssessor: FilterViewModel[] = [];
  searchedAssessorDel: FilterViewModel[] = [];
  searchedReviewer: FilterViewModel[] = [];
  searchedReviewerDel: FilterViewModel[] = [];
  searchedImptOwner: FilterViewModel[] = [];
  searchedOwnerDel: FilterViewModel[] = [];
  searchedTopics: FilterViewModel[] = [];
  searchedJurisdiction: any[] = [];
  searchedActionOwner: FilterViewModel[] = [];


  searchedJuris: ItemIdModel[] = [];
  selectedJuris: ItemIdModel[] = [];

  allSearchedAssessor: FilterViewModel[] = [];
  allSearchedAssessorDel: FilterViewModel[] = [];
  allSearchedReviewer: FilterViewModel[] = [];
  allSearchedReviewerDel: FilterViewModel[] = [];
  allSearchedImptOwner: FilterViewModel[] = [];
  allSearchedOwnerDel: FilterViewModel[] = [];
  allSearchedTopic: FilterViewModel[] = [];
  allSearchedActionOwner: FilterViewModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;
  searchAssessorCntrl: FormControl = new FormControl();
  searchAssessorDelCntrl: FormControl = new FormControl();
  searchReviewerCntrl: FormControl = new FormControl();
  searchReviewerDelCntrl: FormControl = new FormControl();
  searchImptOwnerCntrl: FormControl = new FormControl();
  searchOwnerDelCntrl: FormControl = new FormControl();
  searchTopicCntrl: FormControl = new FormControl();
  searchActionOwnerCntrl: FormControl = new FormControl();

  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;

  @ViewChild('assessorDelInput')
  assessorDelInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorDelAutocomplete')
  assessorDelAutocomplete!: MatAutocomplete;

  @ViewChild('reviewerInput')
  reviewerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerAutocomplete')
  reviewerAutocomplete!: MatAutocomplete;

  @ViewChild('reviewerDelInput')
  reviewerDelInput!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerDelAutocomplete')
  reviewerDelAutocomplete!: MatAutocomplete;

  @ViewChild('imptOwnerInput')
  imptOwnerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('imptOwnerAutocomplete')
  imptOwnerAutocomplete!: MatAutocomplete;

  @ViewChild('ownerDelInput')
  ownerDelInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ownerDelAutocomplete')
  ownerDelAutocomplete!: MatAutocomplete;

  @ViewChild('topicInput')
  topicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('topicAutoComplete')
  topicAutoComplete!: MatAutocomplete;
  @ViewChild('actionOwnerAutocomplete')
  actionOwnerAutocomplete!: MatAutocomplete;
  @ViewChild('ownerInput')
  ownerInput!: ElementRef<HTMLInputElement>;

  @ViewChild('trigautoLegalEntity')
  trigautoLegalEntity: MatAutocompleteTrigger | undefined;
  //= new MatAutocompleteTrigger;
  @ViewChild('trigautoLineOfBusiness')
  trigautoLineOfBusiness: MatAutocompleteTrigger | undefined;
  // = new MatAutocompleteTrigger;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  ruleType: Array<string> = [];
  assessmentStatus: Array<string> = [];
  reviewStatus: Array<string> = [];
  implementationType: Array<string> = [];
  implementationStatus: Array<string> = [];
  templateNo: number = 0;
  assessorToggle: boolean = false;
  complianceToggle: boolean = false;
  jurisdictions: JurisdictionsList = new JurisdictionsList;
  alertDialogModel: AlertDialogModel;
  isDeleteAllTopic: boolean = false;
  lineOfBusiness: Array<string> = [];
  lineOfBusinessDD: string[] = [];

  impactDetails: string | undefined;
  implementationDetails: string | undefined;
  publicationDetails: string | undefined;
  // public Editor = customBuild;

  constructor(
    private impactService: ImpactService, private jsonPipe: JsonPipe, public dialog: MatDialog,
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<BulkUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public templateno: any,
    public sanitizer: DomSanitizer
  ) {
    this.templateNo = this.templateno;
    this.toastModel = new ToastViewModel();
    this.impactAssessment = new ImpactAssessment();
    this.impactAssessmentDD = new ImpactAssessmentDetailsDD();
    this.userAccessToken = new UserProfile();
    // this.getImpactAssesmentDropdownList('');
    this.alertDialogModel = new AlertDialogModel();
    this.impactAssessment.assessmentDetailsList = [];
    this.impactAssessment.assessmentDetailsList2 = [];
    this.selectedEntity = '';
  }

  ngOnInit(): void {
    this.impactAssessment.assessmentDetailsList.push({} as ImpactAssessmentAssessmentDetailsList);
    this.impactAssessment.assessmentDetailsList2.push({} as ImpactAssessmentAssessmentDetailsList2);
    this.getUserProfile();
    this.fetchJurisdiction();
    this.fetchImpactAssessmentDD();
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
      this.userAccessToken = result;
    });
  }

  getImpactAssesmentDropdownList(jurisdiction: string): void {
    this.impactService.getImpactAssesmentDropDownList(jurisdiction).subscribe((result: ImpactAssessmentDropDownList) => {
      if (result.templateno == 3) {
        this.legalEntityList = result.legalEntity;
        this.legalEntityDD = this.legalEntityList;
        this.allLegalEntityDD = this.legalEntityList;
      }
      result.currentStatus.forEach(element => {
        this.assessmentStatus.push(element.title)
      });
      result.reviewStatus.forEach(element => {
        this.reviewStatus.push(element.title)
      });
      result.implementationType.forEach(element => {
        this.implementationType.push(element.title)
      });
      result.ruleType.forEach(element => {
        this.ruleType.push(element.title)
      });
      result.implementationStatus.forEach(element => {
        this.implementationStatus.push(element.title)
      });
      result.lineOfBusiness.forEach(element => {
        this.lineOfBusiness.push(element.title)
        this.allLineOfBusiness = this.lineOfBusiness;
      });
      this.searchLegalEntityCntrl.valueChanges.subscribe((term: any) => {
        this.legalEntityDD = term ? this.filterLegalEntityOnKeydown(term) : this.allLegalEntityDD;
      });
      this.searchLineOfBusinessCntrl.valueChanges.subscribe((term: any) => {
        this.lineOfBusiness = term ? this.filterLineOfBusinessOnKeydown(term) : this.allLineOfBusiness;
      });
    });
  }


  fetchJurisdiction(): void {
    this.impactService.GetJurisdictionsList().subscribe((result: JurisdictionsList) => {
      this.jurisdictions = result;

      this.searchedJurisdiction = this.jurisdictions.jurisdictions;
    })
  }
  fetchImpactAssessmentDD(): void {
    this.isLoadingDD = true;
    this.impactService.getImpactAssessmentDD().subscribe((result: ImpactAssessmentDetailsDD) => {
      this.isLoadingDD = false;
      this.impactAssessmentDD = result;
      this.ddListData();
      this.selectedDDvalue();
    });
  }

  ddListData(): void {
    this.searchedAssessor = this.impactAssessmentDD.assessor;
    this.searchedAssessorDel = this.impactAssessmentDD.assessorDelegate;
    this.searchedReviewer = this.impactAssessmentDD.reviewer;
    this.searchedReviewerDel = this.impactAssessmentDD.reviewerDelegate;
    this.searchedImptOwner = this.impactAssessmentDD.implementationOwner;
    this.searchedOwnerDel = this.impactAssessmentDD.ownerDelegate;
    this.searchedJuris = this.impactAssessmentDD.jurisdiction;
    this.searchedTopics = this.impactAssessmentDD.ruleTopics;
    this.searchedActionOwner = this.impactAssessmentDD.assessor;

    this.allSearchedAssessor = this.impactAssessmentDD.assessor;
    this.allSearchedAssessorDel = this.impactAssessmentDD.assessorDelegate;
    this.allSearchedReviewer = this.impactAssessmentDD.reviewer;
    this.allSearchedReviewerDel = this.impactAssessmentDD.reviewerDelegate;
    this.allSearchedImptOwner = this.impactAssessmentDD.implementationOwner;
    this.allSearchedOwnerDel = this.impactAssessmentDD.ownerDelegate;
    this.allSearchedTopic = this.impactAssessmentDD.ruleTopics;
    this.allSearchedActionOwner = this.impactAssessmentDD.assessor;

    this.searchTopicCntrl.valueChanges.subscribe((term: any) => {
      this.searchedTopics = term ? this.filterTopic(term) : this.impactAssessmentDD.ruleTopics;
    });
    this.searchAssessorCntrl.valueChanges.subscribe((term: any) => {
      this.searchedAssessor = term ? this.filterAssessor(term) : this.impactAssessmentDD.assessor;
    });
    this.searchActionOwnerCntrl.valueChanges.subscribe((term: any) => {
      this.searchedActionOwner = term ? this.filterActionOwner(term) : this.impactAssessmentDD.assessor;
      this.searchedJurisdiction = term ? this.filterJurisdiction(term) : this.jurisdictions.jurisdictions;
    });
    this.searchAssessorDelCntrl.valueChanges.subscribe((term: any) => {
      this.searchedAssessorDel = term ? this.filterAssessorDelegate(term) : this.impactAssessmentDD.assessorDelegate;
      this.searchedJurisdiction = term ? this.filterJurisdiction(term) : this.jurisdictions.jurisdictions;
    });
    this.searchReviewerCntrl.valueChanges.subscribe((term: any) => {
      this.searchedReviewer = term ? this.filterReviewer(term) : this.impactAssessmentDD.reviewer;
      this.searchedJurisdiction = term ? this.filterJurisdiction(term) : this.jurisdictions.jurisdictions;
    });
    this.searchReviewerDelCntrl.valueChanges.subscribe((term: any) => {
      this.searchedReviewerDel = term ? this.filterReviewerDelegate(term) : this.impactAssessmentDD.reviewerDelegate;
    });
    this.searchImptOwnerCntrl.valueChanges.subscribe((term: any) => {
      this.searchedImptOwner = term ? this.filterImplementationOwner(term) : this.impactAssessmentDD.implementationOwner;
    });
    this.searchOwnerDelCntrl.valueChanges.subscribe((term: any) => {
      this.searchedOwnerDel = term ? this.filterOwnerDel(term) : this.impactAssessmentDD.ownerDelegate;
    });
  }

  selectedDDvalue(): void {
    this.lineOfBusinessDD = this.impactAssessment.assessor ? this.impactAssessment.assessor.split(',') : this.assessorDD;
    this.assessorDD = this.impactAssessment.assessor
      ? this.impactAssessment.assessor.split(',')
      : this.assessorDD;
    this.assessorDelDD = this.impactAssessment.assessorDelegate
      ? this.impactAssessment.assessorDelegate.split(',')
      : this.assessorDelDD;
    this.reviewerDD = this.impactAssessment.reviewer
      ? this.impactAssessment.reviewer.split(',')
      : this.reviewerDD;
    this.reviewerDelDD = this.impactAssessment.reviewerDelegate
      ? this.impactAssessment.reviewerDelegate.split(',')
      : this.reviewerDelDD;
    this.imptOwnerDD = this.impactAssessment.implementationOwner
      ? this.impactAssessment.implementationOwner.split(',')
      : this.imptOwnerDD;
    this.ownerDelDD = this.impactAssessment.ownerDelegate
      ? this.impactAssessment.ownerDelegate.split(',')
      : this.ownerDelDD;
    if (this.impactAssessment.jurisdiction) {
      this.impactAssessment.jurisdiction.split(',').forEach(juris => {
        this.selectedJuris.push({ id: 0, name: juris });
      });
    }
  }

  onSelectJuris(event: any) {
    this.getImpactAssesmentDropdownList(event.name);
    this.impactAssessment.jurisdiction = event.name;
  }

  removeLegalEntity(event: string): void {
    let legalEntityArray: string[] = [];
    if (this.selectedEntity) {
      legalEntityArray = this.selectedEntity.split(",");
    }
    const index = (legalEntityArray as string[]).indexOf(event);

    if (index >= 0) {
      (legalEntityArray as string[]).splice(index, 1);
      this.filterAllLegalEntity(legalEntityArray);
      this.selectedEntity = legalEntityArray.join(',');
    }
  }

  selectedLegalEntityEvent(event: MatAutocompleteSelectedEvent): void {
    let legalEntityArray: string[] = [];
    if (this.selectedEntity) {
      legalEntityArray = this.selectedEntity.split(",");
    }
    if (legalEntityArray) {
      let sameValueRow = legalEntityArray.filter(
        obj => obj === event.option.value);
      if (sameValueRow.length == 0) {
        legalEntityArray.push(event.option.value);
      }
    } else {
      legalEntityArray = [];
      legalEntityArray.push(event.option.viewValue);
    }
    this.filterAllLegalEntity(legalEntityArray);
    this.selectedEntity = legalEntityArray.join(',');
    if (this.LegalEntityInput) {
      this.LegalEntityInput.nativeElement.value = '';
    }
    this.searchLegalEntityCntrl.setValue(null);
    this.searchLegalEntityCntrl.disable();
    this.searchLegalEntityCntrl.enable();
  }

  addLegalEntity(event: MatChipInputEvent): void {
    let legalEntityArray: string[] = [];
    if (this.selectedEntity) {
      legalEntityArray = this.selectedEntity.split(",");
    }
    const input = event.chipInput?.inputElement;
    const value = event.value;
    if ((value || '').trim()) {
      let sameValueRow = legalEntityArray.filter(
        obj => obj === value);

      if (sameValueRow.length == 0) {
        (legalEntityArray as string[]).push(value);
        this.selectedEntity = legalEntityArray.join(',');
      }
    }
    if (input) {
      input.value = '';
    }
    this.searchLegalEntityCntrl.setValue(null);
  }

  filterAllLegalEntity(legalEntityArray: any) {
    const filteredArray = this.allLegalEntityDD.filter(item => !legalEntityArray.includes(item.title));
    this.legalEntityDD = filteredArray;
  }

  filterLegalEntityOnKeydown(legalEntity: string): any {
    return this.allLegalEntityDD.filter(option =>
      option.title.toLowerCase().includes(legalEntity.toLowerCase())
    );
  }

  addLineOfBusiness(event: MatChipInputEvent): void {
    let lineOfBusinessArray: string[] = [];
    if (this.impactAssessment.lineOfBusiness) {
      lineOfBusinessArray = this.impactAssessment.lineOfBusiness.split(",");
    }
    const input = event.chipInput?.inputElement;
    const value = event.value;
    if ((value || '').trim()) {
      let sameValueRow = lineOfBusinessArray.filter(
        obj => obj === value);

      if (sameValueRow.length == 0) {
        (lineOfBusinessArray as string[]).push(value);
        this.impactAssessment.lineOfBusiness = lineOfBusinessArray.join(',');
      }
    }

    if (input) {
      input.value = '';
    }
    this.searchLineOfBusinessCntrl.setValue(null);
  }

  selectedLineOfBusinessEvent(event: MatAutocompleteSelectedEvent): void {
    let lineOfBusinessArray: string[] = [];
    if (this.impactAssessment.lineOfBusiness) {
      lineOfBusinessArray = this.impactAssessment.lineOfBusiness.split(",");
    }
    if (lineOfBusinessArray) {
      let sameValueRow = lineOfBusinessArray.filter(
        obj => obj === event.option.value);
      if (sameValueRow.length == 0) {
        lineOfBusinessArray.push(event.option.value);
      }
    } else {
      lineOfBusinessArray = [];
      lineOfBusinessArray.push(event.option.viewValue);
    }
    this.filterAllLineOfBusiness(lineOfBusinessArray);
    this.impactAssessment.lineOfBusiness = lineOfBusinessArray.join(',');
    if (this.LineOfBusinessInput) {
      this.LineOfBusinessInput.nativeElement.value = '';
    }
    this.searchLineOfBusinessCntrl.setValue(null);
    this.searchLineOfBusinessCntrl.disable();
    this.searchLineOfBusinessCntrl.enable();
  }

  removeLineOfBusiness(event: string): void {
    let lineOfBusinessArray: string[] = [];
    if (this.impactAssessment.lineOfBusiness) {
      lineOfBusinessArray = this.impactAssessment.lineOfBusiness.split(",");
    }
    const index = (lineOfBusinessArray as string[]).indexOf(event);

    if (index >= 0) {
      (lineOfBusinessArray as string[]).splice(index, 1);
      this.filterAllLineOfBusiness(lineOfBusinessArray);
      this.impactAssessment.lineOfBusiness = lineOfBusinessArray.join(',');
    }
  }

  filterAllLineOfBusiness(lineOfBusinessArray: any) {
    const filteredArray = this.allLineOfBusiness.filter(item => !lineOfBusinessArray.includes(item));
    this.lineOfBusiness = filteredArray;
  }

  filterLineOfBusinessOnKeydown(lineOfBusiness: string): any {
    return this.allLineOfBusiness.filter(option =>
      option.toLowerCase().includes(lineOfBusiness.toLowerCase())
    );
  }

  updateImpactAssessment(): void {
    this.impactAssessment.templateNo = this.templateNo;
    if(this.impactAssessment.templateNo == 2){
      let position:number[] = [];
      for (let i = 0; i < this.impactAssessment.assessmentDetailsList2.length; i++) {
        let item = this.impactAssessment.assessmentDetailsList2[i];
        if (Object.keys(item).length === 0) {
          position.push(i);
        }
      }
      this.impactAssessment.assessmentDetailsList2 = this.impactAssessment.assessmentDetailsList2.filter(function (value, index) {
        return position.indexOf(index) == -1;
      })

      if (this.impactAssessment.assessmentDetailsList2.length > 0) {
        this.impactAssessment.actionsRequired = this.jsonPipe.transform(this.impactAssessment.assessmentDetailsList2);
      }
      else {
        this.impactAssessment.actionsRequired = null;
      }
      for (let i = 0; i < this.impactAssessment.assessmentDetailsList2.length; i++) {
        if (this.impactAssessment.assessmentDetailsList2[i].actionsTaken == '' && this.impactAssessment.assessmentDetailsList2[i].actionOwner == '' && this.impactAssessment.assessmentDetailsList2[i].actionStatus == '' && this.impactAssessment.assessmentDetailsList2[i].actionsRequired == '' && this.impactAssessment.assessmentDetailsList2[i].nextActionDate == null) {
          delete this.impactAssessment.assessmentDetailsList2[i];
        }
      }
    }
    if (this.impactAssessment.templateNo == 3) {
      this.impactAssessment.legalEntity = this.selectedEntity;
      let position: number[] = [];
      for (let i = 0; i < this.impactAssessment.assessmentDetailsList.length; i++) {
        let item = this.impactAssessment.assessmentDetailsList[i];
        if (Object.keys(item).length === 0) {
          position.push(i);
        }
      }
      this.impactAssessment.assessmentDetailsList = this.impactAssessment.assessmentDetailsList.filter(function (value, index) {
        return position.indexOf(index) == -1;
      })

      if (this.impactAssessment.assessmentDetailsList.length > 0) {
        this.impactAssessment.actionsRequired = this.jsonPipe.transform(this.impactAssessment.assessmentDetailsList);
      }
      else {
        this.impactAssessment.actionsRequired = '';
      }
      for (let i = 0; i < this.impactAssessment.assessmentDetailsList.length; i++) {
        if (this.impactAssessment.assessmentDetailsList[i].actionOwner == '' && this.impactAssessment.assessmentDetailsList[i].actionStatus == '' && this.impactAssessment.assessmentDetailsList[i].actionsRequired == '' && this.impactAssessment.assessmentDetailsList[i].nextActionDate == null) {
          delete this.impactAssessment.assessmentDetailsList[i];
        }
      }
    }
    this.impactAssessment.assessor = this.assessorDD.toString();
    this.impactAssessment.assessorDelegate = this.assessorDelDD.toString();
    this.impactAssessment.reviewer = this.reviewerDD.toString();
    this.impactAssessment.reviewerDelegate = this.reviewerDelDD.toString();
    this.impactAssessment.implementationOwner = this.imptOwnerDD.toString();
    this.impactAssessment.ownerDelegate = this.ownerDelDD.toString();
   
    this.impactAssessment.applicationDate = this.impactAssessment
      .applicationDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.applicationDate.toString()
      )
      : null;
    this.impactAssessment.assessmentLastEdited = this.impactAssessment
      .assessmentLastEdited
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.assessmentLastEdited.toString()
      )
      : null;
    this.impactAssessment.assessmentDueDate = this.impactAssessment
      .assessmentDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.assessmentDueDate.toString()
      )
      : null;
    this.impactAssessment.reviewLastEdited = this.impactAssessment
      .reviewLastEdited
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.reviewLastEdited.toString()
      )
      : null;
    this.impactAssessment.reviewDueDate = this.impactAssessment.reviewDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.reviewDueDate.toString()
      )
      : null;
    this.impactAssessment.implementationLastEdited = this.impactAssessment
      .implementationLastEdited
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.implementationLastEdited.toString()
      )
      : null;
    this.impactAssessment.implementationDueDate = this.impactAssessment
      .implementationDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.implementationDueDate.toString()
      )
      : null;
    this.impactAssessment.userId = this.userAccessToken.externalUserId;
    this.impactAssessment.userName = this.userAccessToken.fullName;
    if (this.impactAssessment.jurisdiction != (null || '')) {
      if (this.templateNo == 3 && this.impactAssessment.isLobbyingRequired != (null || '') && this.impactAssessment.legalEntity != (null || '') && this.impactAssessment.lineOfBusiness != (null || '') && this.impactAssessment.assessor != (null || '')
        && this.impactAssessment.assessmentDetails1 != (null || '') && this.impactAssessment.assessmentDetails2 != (null || '') && this.impactAssessment.impactRatingLite != (null || '')) {
        this.dialogRef.close(this.impactAssessment);
      }
      else if (this.templateNo != 3) {
        this.dialogRef.close(this.impactAssessment);
      }
      else {
        this.alertMessage("warning", "** fields are mandatory");
      }
    }
    else {
      this.alertMessage("warning", "Please Select Your Division.");
    }
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }

  // Assessor multiselect
  filterAssessor(search: string): any {
    return this.searchedAssessor.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterActionOwner(search: string): any {
    return this.searchedActionOwner.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterJurisdiction(search: string): any {
    return this.searchedJurisdiction.filter(option =>
      option.title.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAssessor(event: MatChipInputEvent): void {
    if (!this.assessorAutocomplete.isOpen) {
      const input = event.chipInput?.inputElement;
      const value = event.value;

      if ((value || '').trim()) {
        (this.assessorDD as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchAssessorCntrl.setValue(null);
    }
  }

  selectedAssessorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDD) {
      this.assessorDD.push(event.option.viewValue);
    } else {
      this.assessorDD = [];
      this.assessorDD.push(event.option.viewValue);
    }
    this.assessorInput.nativeElement.value = '';
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
  }

  removeAssessor(status: string): void {
    const index = (this.assessorDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDD as string[]).splice(index, 1);
    }
  }

  // Assessor Delegate multiselect
  filterAssessorDelegate(search: string): any {
    return this.searchedAssessorDel.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAssessorDelegate(event: MatChipInputEvent): void {
    if (!this.assessorDelAutocomplete.isOpen) {
      const input = event.chipInput?.inputElement;
      const value = event.value;

      if ((value || '').trim()) {
        (this.assessorDelDD as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchAssessorDelCntrl.setValue(null);
    }
  }

  selectedAssessorDelegateEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDelDD) {
      this.assessorDelDD.push(event.option.viewValue);
    } else {
      this.assessorDelDD = [];
      this.assessorDelDD.push(event.option.viewValue);
    }
    this.assessorDelInput.nativeElement.value = '';
    this.searchAssessorDelCntrl.setValue(null);
    this.searchAssessorDelCntrl.disable();
    this.searchAssessorDelCntrl.enable();
  }

  removeAssessorDelegate(status: string): void {
    const index = (this.assessorDelDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDelDD as string[]).splice(index, 1);
    }
  }

  // Reviewer multiselect
  filterReviewer(search: string): any {
    return this.searchedReviewer.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addReviewer(event: MatChipInputEvent): void {
    if (!this.reviewerAutocomplete.isOpen) {
      const input = event.chipInput?.inputElement;
      const value = event.value;

      if ((value || '').trim()) {
        (this.reviewerDD as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchReviewerCntrl.setValue(null);
    }
  }

  selectedReviewerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDD) {
      this.reviewerDD.push(event.option.viewValue);
    } else {
      this.reviewerDD = [];
      this.reviewerDD.push(event.option.viewValue);
    }
    this.reviewerInput.nativeElement.value = '';
    this.searchReviewerCntrl.setValue(null);
    this.searchReviewerCntrl.disable();
    this.searchReviewerCntrl.enable();
  }

  removeReviewer(status: string): void {
    const index = (this.reviewerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDD as string[]).splice(index, 1);
    }
  }

  // Reviewer Delegate multiselect
  filterReviewerDelegate(search: string): any {
    return this.searchedReviewerDel.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addReviewerDelegate(event: MatChipInputEvent): void {
    if (!this.reviewerDelAutocomplete.isOpen) {
      const input = event.chipInput?.inputElement;
      const value = event.value;

      if ((value || '').trim()) {
        (this.reviewerDelDD as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchReviewerDelCntrl.setValue(null);
    }
  }

  selectedReviewerDelegateEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDelDD) {
      this.reviewerDelDD.push(event.option.viewValue);
    } else {
      this.reviewerDelDD = [];
      this.reviewerDelDD.push(event.option.viewValue);
    }
    this.reviewerDelInput.nativeElement.value = '';
    this.searchReviewerDelCntrl.setValue(null);
    this.searchReviewerDelCntrl.disable();
    this.searchReviewerDelCntrl.enable();
  }

  removeReviewerDelegate(status: string): void {
    const index = (this.reviewerDelDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDelDD as string[]).splice(index, 1);
    }
  }

  // Implementation Owner multiselect
  filterImplementationOwner(search: string): any {
    return this.searchedImptOwner.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addImplementationOwner(event: MatChipInputEvent): void {
    if (!this.imptOwnerAutocomplete.isOpen) {
      const input = event.chipInput?.inputElement;
      const value = event.value;

      if ((value || '').trim()) {
        (this.imptOwnerDD as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchImptOwnerCntrl.setValue(null);
    }
  }

  selectedImplementationOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.imptOwnerDD) {
      this.imptOwnerDD.push(event.option.viewValue);
    } else {
      this.imptOwnerDD = [];
      this.imptOwnerDD.push(event.option.viewValue);
    }
    this.imptOwnerInput.nativeElement.value = '';
    this.searchImptOwnerCntrl.setValue(null);
    this.searchImptOwnerCntrl.disable();
    this.searchImptOwnerCntrl.enable();
  }

  removeImplementationOwner(status: string): void {
    const index = (this.imptOwnerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.imptOwnerDD as string[]).splice(index, 1);
    }
  }

  // Owner Delegate multiselect
  filterOwnerDel(search: string): any {
    return this.searchedOwnerDel.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addOwnerDel(event: MatChipInputEvent): void {
    if (!this.ownerDelAutocomplete.isOpen) {
      const input = event.chipInput?.inputElement;
      const value = event.value;

      if ((value || '').trim()) {
        (this.ownerDelDD as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchOwnerDelCntrl.setValue(null);
    }
  }

  selectedOwnerDelEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.ownerDelDD) {
      this.ownerDelDD.push(event.option.viewValue);
    } else {
      this.ownerDelDD = [];
      this.ownerDelDD.push(event.option.viewValue);
    }
    this.ownerDelInput.nativeElement.value = '';
    this.searchOwnerDelCntrl.setValue(null);
    this.searchOwnerDelCntrl.disable();
    this.searchOwnerDelCntrl.enable();
  }

  removeOwnerDel(status: string): void {
    const index = (this.ownerDelDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.ownerDelDD as string[]).splice(index, 1);
    }
  }

  // Topic multiselect
  filterTopic(search: string): any {
    return this.searchedTopics.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addTopic(event: MatChipInputEvent): void {
    if (!this.topicAutoComplete.isOpen) {
      const input = event.chipInput?.inputElement;
      const value = event.value;

      if ((value || '').trim()) {
        (this.topicDD as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchTopicCntrl.setValue(null);
    }
  }

  selectedTopicEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.topicDD) {
      this.topicDD.push(event.option.viewValue);
    } else {
      this.topicDD = [];
      this.topicDD.push(event.option.viewValue);
    }
    this.topicInput.nativeElement.value = '';
    this.searchTopicCntrl.setValue(null);
    this.searchTopicCntrl.disable();
    this.searchTopicCntrl.enable();
  }

  removeTopic(status: string): void {
    const index = (this.topicDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.topicDD as string[]).splice(index, 1);
    }
  }

  checkReviewDetailRequired(event: string): void {
    if (event === 'Checked') {
      this.isRDNotRequired = true;
      this.isRDetailPermission = false;
      this.impactAssessment.reviewDueDate = MasterHelper.getDate(0);
      this.impactAssessment.reviewLastEdited = MasterHelper.getDate(0);
      this.impactAssessment.reviewStatus = 'Not Required';
    } else {
      this.isRDNotRequired = false;
      this.isRDetailPermission = true;
    }
  }

  checkImplementationDetailRequired(event: string): void {
    if (event === 'Checked') {
      this.isIDNotRequired = true;
      this.isIDetailPermission = false;
      this.impactAssessment.implementationDueDate = MasterHelper.getDate(0);
      this.impactAssessment.implementationLastEdited = MasterHelper.getDate(0);
      this.impactAssessment.implementationStatus = 'Not Required';
    } else {
      this.isIDNotRequired = false;
      this.isIDetailPermission = true;
    }
  }

  getFilteredData(filter: string, event: any): void {
    this.searchStr += event.key;
    switch (filter) {
      case 'Assessor':
        const searchedA = Array<FilterViewModel>();
        if (this.searchedAssessor.length > 0) {
          this.searchedAssessor.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedA.push(element);
            }
          });
          this.searchedAssessor = searchedA;
        } else {
          this.searchedAssessor = this.allSearchedAssessor;
        }
        break;
      case 'AssessorDelegate':
        const searchedAD = Array<FilterViewModel>();
        if (this.searchedAssessorDel.length > 0) {
          this.searchedAssessorDel.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedAD.push(element);
            }
          });
          this.searchedAssessorDel = searchedAD;
        } else {
          this.searchedAssessorDel = this.allSearchedAssessorDel;
        }
        break;
      case 'Reviewer':
        const searchedR = Array<FilterViewModel>();
        if (this.searchedReviewer.length > 0) {
          this.searchedReviewer.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedR.push(element);
            }
          });
          this.searchedReviewer = searchedR;
        } else {
          this.searchedReviewer = this.allSearchedReviewer;
        }
        break;
      case 'ReviewerDelegate':
        const searchedRD = Array<FilterViewModel>();
        if (this.searchedReviewerDel.length > 0) {
          this.searchedReviewerDel.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedRD.push(element);
            }
          });
          this.searchedReviewerDel = searchedRD;
        } else {
          this.searchedReviewerDel = this.allSearchedReviewerDel;
        }
        break;
      case 'Owner':
        const searchedO = Array<FilterViewModel>();
        if (this.searchedImptOwner.length > 0) {
          this.searchedImptOwner.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedO.push(element);
            }
          });
          this.searchedImptOwner = searchedO;
        } else {
          this.searchedImptOwner = this.allSearchedImptOwner;
        }
        break;
      case 'OwnerDelegate':
        const searchedOD = Array<FilterViewModel>();
        if (this.searchedOwnerDel.length > 0) {
          this.searchedImptOwner.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedOD.push(element);
            }
          });
          this.searchedOwnerDel = searchedOD;
        } else {
          this.searchedOwnerDel = this.allSearchedOwnerDel;
        }
        break;
    }
    this.searchStr = '';
  }

  addAssessmentDetails() {
    if(this.templateNo == 2){
      this.impactAssessment.assessmentDetailsList2.push({} as ImpactAssessmentAssessmentDetailsList2);
    }
    else{
      this.impactAssessment.assessmentDetailsList.push({} as ImpactAssessmentAssessmentDetailsList);
    }
  }

  removeMultipleActionOwner(status: string, row: number): void {
    let ownerArray: string[] = [];
    if(this.templateNo == 2){
      if (this.impactAssessment.assessmentDetailsList2[row].actionOwner) {
        ownerArray = this.impactAssessment.assessmentDetailsList2[row].actionOwner.split(",");
      }
      const index = (ownerArray as string[]).indexOf(status);
  
      if (index >= 0) {
        (ownerArray as string[]).splice(index, 1);
        this.impactAssessment.assessmentDetailsList2[row].actionOwner = ownerArray.toString();
      }
    }
    else{
      if (this.impactAssessment.assessmentDetailsList[row].actionOwner) {
        ownerArray = this.impactAssessment.assessmentDetailsList[row].actionOwner.split(",");
      }
      const index = (ownerArray as string[]).indexOf(status);
  
      if (index >= 0) {
        (ownerArray as string[]).splice(index, 1);
        this.impactAssessment.assessmentDetailsList[row].actionOwner = ownerArray.toString();
      }
    }
  }

  addActionOwner(event: MatChipInputEvent, actionOwnerstring: string, row: number): void {
    const input = event.chipInput?.inputElement;
    const value = event.value;
    let rowInDropdownList = this.searchedActionOwner.filter(
      obj => obj.name === value);
    if (!this.actionOwnerAutocomplete.isOpen && rowInDropdownList.length > 0) {
      if ((value || '').trim()) {
        let ownerArray: any = [];
        if (actionOwnerstring) {
          ownerArray = actionOwnerstring.split(",");
        }
        let sameValueRow = ownerArray.filter(
          (obj: string) => obj === value);

        if (sameValueRow.length == 0) {
          ownerArray.push(value);
          if(this.templateNo == 2){
            this.impactAssessment.assessmentDetailsList2[row].actionOwner = ownerArray.toString();
          }
          else{
            this.impactAssessment.assessmentDetailsList[row].actionOwner = ownerArray.toString();
          }
        }
      }
      else {
        if(this.templateNo == 2){
          this.impactAssessment.assessmentDetailsList2[row].actionOwner = actionOwnerstring.toString();
        }
        else{
          this.impactAssessment.assessmentDetailsList[row].actionOwner = actionOwnerstring.toString();
        }
      }

      if (input) {
        input.value = '';
      }
      this.searchActionOwnerCntrl.setValue(null);
    }
  }

  selectedMultipleActionOwnerEvent(event: MatAutocompleteSelectedEvent, actionOwnerstring: string, row: number): void {
    let ownerArray: any = [];
    if (actionOwnerstring) {
      ownerArray = actionOwnerstring.split(",");
    }
    let sameValueRow = ownerArray.filter(
      (obj: string) => obj === event.option.viewValue);
    if (sameValueRow.length == 0) {
      ownerArray.push(event.option.viewValue);
      if(this.templateNo == 2){
        this.impactAssessment.assessmentDetailsList2[row].actionOwner = ownerArray.toString();
      }
      else{
        this.impactAssessment.assessmentDetailsList[row].actionOwner = ownerArray.toString();
      }
      this.ownerInput.nativeElement.value = '';
      this.searchActionOwnerCntrl.setValue(null);
      this.searchActionOwnerCntrl.disable();
      this.searchActionOwnerCntrl.enable();
    }
    else {
      if(this.templateNo == 2){
        this.impactAssessment.assessmentDetailsList2[row].actionOwner = actionOwnerstring.toString();
      }
      else{
        this.impactAssessment.assessmentDetailsList[row].actionOwner = actionOwnerstring.toString();
      }
      this.ownerInput.nativeElement.value = '';
      this.searchActionOwnerCntrl.setValue(null);
      this.searchActionOwnerCntrl.disable();
      this.searchActionOwnerCntrl.enable();
    }
  }

  removeAssessmentDetails(index: number) {
    if (this.templateNo == 3 && this.impactAssessment.assessmentDetailsList.length <= 1) {
    }
    else if(this.templateNo == 2 && this.impactAssessment.assessmentDetailsList2.length <= 1){
    }
    else {
      this.openDeleteDialog(index);
    }
  }

  openDeleteDialog(index: number): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Delete Item') {
        if(this.templateNo == 2){
          this.impactAssessment.assessmentDetailsList2.splice(index, 1);
        }
        else{
          this.impactAssessment.assessmentDetailsList.splice(index, 1);
        }
        this.isDeleteAllTopic = false;
      }
      else {
        this.isDeleteAllTopic = false;
      }
    });
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
export interface legalData {
  id: number;
  title: string;
}
